var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 6.19L17 10.69V18.5H15V12.5H9V18.5H7V10.69L12 6.19V6.19ZM12 3.5L2 12.5H5V20.5H11V14.5H13V20.5H19V12.5H22L12 3.5Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }